export enum DRIVERS_DAY_LIMITS {
  Overdue = 29,
  Warning = 15,
  Safe = 1,
  Today = 0,
}

export enum VEHICLES_DAY_LIMITS {
  Overdue = 91,
  Warning = 61,
  Safe = 1,
  Today = 0,
}
